<ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
    </div>
</ng-container>
<div class="app-theme">
    <body class="a">
        <div class="topborder">
            <div class="topInLine">
                <select class="form-control" [(ngModel)]="Selectedvenue" (change) = "onVenueChange()">
                    <option value="">Please Select a Venue</option>
                    <option *ngFor="let venue of venuelist" [value]="venue.key">
                      {{venue.value.name }}
                    </option>
                  </select>
            </div>
        </div>
        <ng-container *ngIf="isModalOpen">
            <div class="modal">
              <tm1-card class="modal-content">
                <span class="close" (click)="closeModal()">&times;</span>
                <tm1-typography type="data-l">Resend Attendance Data</tm1-typography>
                <br/>
                <tm1-typography type="data-s">Please choose the date you want to resend the attendance data for</tm1-typography>
                <br/>
                <tm1-typography type="data-s"> </tm1-typography>
                <br/>
                <input [(ngModel)]="date"  (change)="onDateChange()" type="date" id="start" name="trip-start" value="{{date}}"
                 min="2018-01-01" max="{{ currentDate }}" class=" date a form-control" />
                 <br/>
                 <tm1-button (click) = "sendAttendance()">Resend Data</tm1-button>
              </tm1-card>
            </div>
            </ng-container>
            <div class="container">
                <ng-container *ngIf="deliveryList.deliveryPoints && deliveryList.deliveryLatency?.length">
                    <div class="chart-header">
                        <tm1-typography type="heading-s">Delivery Latency</tm1-typography>
                        <tm1-button (click)="getDeliveryFeeds()">Refresh</tm1-button>
                    </div>
                    <div class="chart-container">
                        <canvas baseChart
                            [datasets]="latencyChartData.datasets"
                            [labels]="latencyChartData.labels"
                            [options]="latencyChartOptions"
                            type="line">
                        </canvas>
                    </div>
                </ng-container>
                <tm1-button (click) = "addGatePath()"  style="width:10%;">Add Feed</tm1-button>
                <tm1-typography type="title-page">Current Feeds</tm1-typography>
                <ng-container *ngIf="!deliveryList.deliveryPoints">
                    <tm1-icon style="margin-top: 10%;" slot="media" icon="search"></tm1-icon>
                    <tm1-empty-state style="margin-bottom: 50px;" variant="no-result"
                        title="No Attendance Feeds have been setup"
                        subtitle="Attendance Feeds can be added via the 'Add Feed' button above"></tm1-empty-state>
                </ng-container>
                <div class="feedButtons">
                    <ng-container *ngIf="deliveryList.deliveryPoints">
                      <tm1-button class="editButton" *ngIf="fieldsdisabled" (click)="setEditDisplay()">Edit Feeds</tm1-button>
                      <tm1-button *ngIf="!fieldsdisabled" (click)="editfeed()">Save Changes</tm1-button>
                      <tm1-button class="testButton" id="testButton" color="positive" (click)="testAllFeeds(Selectedvenue)">Test All Feeds</tm1-button>
                      <tm1-tooltip anchor = testButton>Results will take approximately 60 seconds to be reflected <br/>(Please Refresh Page)</tm1-tooltip>
                    </ng-container>
                  </div>
                <ng-container *ngFor="let key of venue.objectKeys(deliveryList.deliveryPoints)">
                    <tm1-card variant = "shadow" class="section">
                        <ng-container *ngIf="deliveryList">
                            <form>
                                <fieldset>
                                    <div class="statusLine">
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].active === 'YES'">
                                            <tm1-typography type ="heading-s">Status:</tm1-typography>
                                            <tm1-badge circular="" appearance="accent" baseColor="success">ACTIVE</tm1-badge>
                                        </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].status === 'PENDING'">
                                            <tm1-typography type ="heading-s">Status</tm1-typography>
                                            <tm1-badge circular="" appearance="accent" baseColor="caution">
                                                PENDING</tm1-badge>
                                        </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].status === 'SUCCESS'">
                                            <tm1-typography type ="heading-s">Last Delivery:</tm1-typography>
                                            <tm1-badge circular="" appearance="accent" baseColor="success">
                                                SUCCESS</tm1-badge>
                                        </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].status === 'FAILURE'">
                                            <tm1-typography type ="heading-s">Last Delivery:</tm1-typography>
                                            <tm1-badge circular="" appearance="accent" baseColor="error">
                                                FAIL</tm1-badge>
                                        </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].active === 'NO'">
                                            <tm1-typography type ="heading-s">Status:</tm1-typography>
                                            <tm1-badge circular="" appearance="accent" baseColor="error">NOT
                                                ACTIVE</tm1-badge>
                                        </ng-container>
                                        <tm1-typography type="subheading-s">Failed Count:{{deliveryList.deliveryPoints[key].failedCount}}</tm1-typography>
                                            <ng-container *ngIf="deliveryList.deliveryPoints[key].failedCount > 0">
                                                <div class="failureText">
                                                <span 
                                                style="cursor: pointer; color: blue; text-decoration: underline;" 
                                                (click)="ResubmitFeed(Selectedvenue, deliveryList.deliveryPoints[key].deliveryName)">
                                                <tm1-typography type = "subheading-s">Resubmit Failures</tm1-typography>
                                            </span>
                                                <tm1-icon-tooltip id="resubmitText" size="small" color="" icon="info">Results will take approximately 60 seconds to be reflected <br/>(Please Refresh Page)</tm1-icon-tooltip>
                                                </div>
                                            </ng-container>
                                    </div>
                                    <tm1-text-field ngDefaultControl disabled="true" class="textField"
                                        appearance="outline" inputsize="regular" label="Delivery Type" type="text"
                                        [(ngModel)]="deliveryList.deliveryPoints[key].type" name="type--{{key}}">
                                    </tm1-text-field>
                                    <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                        appearance="outline" inputsize="regular" label="Delivery Name" type="text"
                                        [(ngModel)]="deliveryList.deliveryPoints[key].deliveryName"
                                        name="deliveryName--{{key}}">
                                    </tm1-text-field>
                                    <ng-container  *ngIf="deliveryList.deliveryPoints[key].type === 'AZURE'">
                                        <tm1-text-area ngDefaultControl disabled="{{fieldsdisabled}}" appearance="outline"
                                            inputsize="regular" label="Access URL" type="text"
                                            [(ngModel)]="deliveryList.deliveryPoints[key].shared_access_url"
                                            name="shared_access_url--{{key}}">
                                        </tm1-text-area>
                                    </ng-container>
                                    <ng-container *ngIf="deliveryList.deliveryPoints[key].type === 'S3'">
                                        <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                            appearance="outline" inputsize="regular" label="Bucket" type="text"
                                            [(ngModel)]="deliveryList.deliveryPoints[key].bucket"
                                            name="bucket--{{key}}">
                                        </tm1-text-field>
                                    </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].type === 'KINESIS'">
                                        <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                            appearance="outline" inputsize="regular" label="event BUS Name" type="text"
                                            [(ngModel)]="deliveryList.deliveryPoints[key].eventBusName"
                                            name="eventBusName--{{key}}">
                                        </tm1-text-field>
                                        <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField" appearance="outline" inputsize="regular"
                                            label="Stream Name" type="text" inputsize="regular"
                                            [(ngModel)]="deliveryList.deliveryPoints[key].streamName"
                                            name="streamName--{{key}}">
                                        </tm1-text-field>
                                        </ng-container>
                                            <ng-container *ngIf="deliveryList.deliveryPoints[key].type === 'SFTP'">
                                            <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                                appearance="outline" inputsize="regular" label="Server" type="text"
                                                [(ngModel)]="deliveryList.deliveryPoints[key].server"
                                                name="server--{{key}}">
                                            </tm1-text-field>
                                            <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                                appearance="outline" inputsize="regular" label="Path" type="text"
                                                [(ngModel)]="deliveryList.deliveryPoints[key].path"
                                                name="path--{{key}}">
                                            </tm1-text-field>
                                            <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                                appearance="outline" inputsize="regular" label="Username" type="text"
                                                [(ngModel)]="deliveryList.deliveryPoints[key].username"
                                                name = "username--{{key}}">
                                            </tm1-text-field>
                                            <tm1-text-field ngDefaultControl disabled="{{fieldsdisabled}}" class="textField"
                                                appearance="outline" inputsize="regular" label="Password" type="text"
                                                 [(ngModel)]="deliveryList.deliveryPoints[key].password"
                                                 name="password--{{key}}">
                                            </tm1-text-field>
                                        </ng-container>
                                        <ng-container *ngIf="deliveryList.deliveryPoints[key].dsnfilters?.length">
                                            <tm1-typography type="body-s">DSN:</tm1-typography>
                                            <div class="send-dates-container">
                                              <div class="chip" *ngFor="let dsn of deliveryList.deliveryPoints[key].dsnfilters; let i = index">
                                                {{ dsn }}
                                                <ng-container *ngIf="!fieldsdisabled">
                                                <span (click)="removeDsn(deliveryList.deliveryPoints[key].deliveryName, i)" class="close-btn">&times;</span>

                                            </ng-container>
                                            </div>
                                        </div>
                                    </ng-container>
                                        <ng-container *ngIf="hasDateFilters(deliveryList.deliveryPoints[key])">
                                            <tm1-typography type="body-s">Send Dates:</tm1-typography>
                                            <div class="send-dates-container">
                                              <ng-container *ngFor="let dateKey of venue.objectKeys(deliveryList.deliveryPoints[key].datefilters)">
                                                <div class="chip">
                                                  <span>
                                                    {{ dateKey }}<ng-container *ngIf="isTimeRange(deliveryList.deliveryPoints[key].datefilters[dateKey])"> ({{ formatTimeRange(deliveryList.deliveryPoints[key].datefilters[dateKey]) }})</ng-container>
                                                  </span>
                                                  <ng-container *ngIf="!fieldsdisabled">
                                                    <span (click)="startEditTimes(deliveryList.deliveryPoints[key].deliveryName, dateKey, deliveryList.deliveryPoints[key].datefilters[dateKey])" class="edit-btn" title="Edit times">&#9998;</span>
                                                    <span (click)="removeChip(deliveryList.deliveryPoints[key].deliveryName, dateKey)" class="close-btn">&times;</span>
                                                  </ng-container>
                                                </div>
                                                <div class="chip-editor" *ngIf="isEditingTimes(deliveryList.deliveryPoints[key].deliveryName, dateKey)">
                                                  <div class="time-range-row">
                                                    <label>
                                                      Start
                                                      <input type="time" [(ngModel)]="editStart" [ngModelOptions]="{standalone: true}" />
                                                    </label>
                                                    <label>
                                                      End
                                                      <input type="time" [(ngModel)]="editEnd" [ngModelOptions]="{standalone: true}" />
                                                    </label>
                                                  </div>
                                                  <div class="time-range-row">
                                                    <tm1-button color="positive" (click)="saveEditTimes(deliveryList.deliveryPoints[key].deliveryName, dateKey)">Save</tm1-button>
                                                    <tm1-button (click)="clearChipTimes(deliveryList.deliveryPoints[key].deliveryName, dateKey)">Clear Times</tm1-button>
                                                    <tm1-button (click)="cancelEditTimes()">Cancel</tm1-button>
                                                  </div>
                                                </div>
                                              </ng-container>
                                            </div>
                                          </ng-container>
                                </fieldset>
                                <br/>
                                <ng-container *ngIf="!fieldsdisabled">

                                    <tm1-text-field ngDefaultControl
                                        (change) = "getDsnValue($event)"
                                        (change)="getDsnValue($event)"
                                        (keydown.enter)="getDsnValue($event); addDsn($event, deliveryList.deliveryPoints[key].deliveryName)"
                                        placeholder="Enter DSN and press Enter"
                                        label="DSNs"
                                        inputsize="regular"
                                        appearance="outline"
                                        ></tm1-text-field>
                                    <tm1-text-area
                                    label="New dates"
                                    supportingText="Dates must be YYYY-MM-DD format"
                                    type="textarea"
                                    (change) = getDates($event)
                                    placeholder="Enter Dates with each date on a new line"
                                    ></tm1-text-area>
                                    <tm1-button
                                    style="margin-top: 10px;"
                                    class="addButton"
                                    color="positive"
                                    (click)="addDate($event, deliveryList.deliveryPoints[key].deliveryName)">
                                    Add Dates
                                </tm1-button>
                             </ng-container>
                             <ng-container *ngIf="fieldsdisabled">
                                <tm1-button (click) = "openModal()">Resend Data</tm1-button>
                                </ng-container>
                            </form>
                        </ng-container>
                    </tm1-card>
                </ng-container>
            </div>
    </body>
</div>